import type { RootObject } from '../types/prefLanguage';

import { useQuery } from '@tanstack/react-query';
import { request } from '../services/request';

export const useLanguagePreference = (enabled = true) => {
    return useQuery<RootObject, Error>(
        ['LanguagePreference'],
        async () => {
            const jsonResponse = await request({
                endpoint: 'contacts/get-LanguagePreference',
            });

            if (!jsonResponse.success) {
                throw new Error(jsonResponse.data.Message || 'Something went wrong');
            }

            return jsonResponse;
        },
        {
            enabled,
    refetchOnWindowFocus: false,  

        }
    );
};
